import React from 'react'
import SuccessMessageUI from '../../../../widgets/form/SuccessMessageUI'
import ErrorMessageUI from '../../../../widgets/form/ErrorMessageUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import ButtonUI from '../../../../widgets/action/ButtonUI'
import './MoveToCsModal.css' // reuse same modal styles

/**
 * SetCSDueDateModalUI
 *
 * A modal popup that lets an su_manage user set (or override) the due date
 * of a CS document that already has a system-computed default due date.
 *
 * Props:
 *   context          - app context
 *   loan             - current loan entity
 *   setDueDateMode   - boolean — controls visibility
 *   selectedFileCode - file code of the CS doc being edited
 *   selectedFileTitle- human-readable title for display
 *   dueDate          - currently selected date (ISO string, e.g. "2026-03-03")
 *   onDueDateChange  - function(isoDateString) called on date picker change
 *   submitted        - boolean — true while the API call is in-flight
 *   successMsg       - string | null
 *   errorList        - string[]
 *   onSubmitClick    - function() called when user clicks "Set Due Date"
 *   onCancelClick    - function() called to close the modal
 */
const SetCSDueDateModalUI = ({
  context,
  loan,
  setDueDateMode,
  selectedFileCode,
  selectedFileTitle,
  dueDate,
  onDueDateChange,
  submitted,
  successMsg,
  errorList,
  onSubmitClick,
  onCancelClick,
}) => {
  if (!setDueDateMode) return null

  const displayTitle = selectedFileTitle || selectedFileCode || 'Document'

  return (
    <div className='move-to-cs-modal-overlay'>
      <div className='move-to-cs-modal-container' style={{ overflow: 'visible' }}>
        <div className='move-to-cs-modal-header'>
          <h3>Set Due Date</h3>
          <button className='move-to-cs-modal-close' onClick={onCancelClick}>×</button>
        </div>

        <div className='move-to-cs-modal-body'>
          <div className='g_m_bottom_100'>
            <p className='g_m_bottom_50'>
              Set a due date for <strong>{displayTitle}</strong>.
            </p>
            <p className='g_muted' style={{ fontSize: '14px' }}>
              This will override the system-computed default due date.
            </p>
          </div>

          <div className='g_m_bottom_100 move-to-cs-date-wrapper'>
            <InputDateUI
              context={context}
              name='csDueDate'
              label='Due Date'
              required={true}
              selectedDateISO={dueDate}
              onChange={onDueDateChange}
              help='Select the due date for this CS document'
              error={errorList && errorList.length > 0}
            />
          </div>

          <SuccessMessageUI show={successMsg} message={successMsg} />
          <ErrorMessageUI errorList={errorList} />
        </div>

        <div className='move-to-cs-modal-footer'>
          <ButtonUI
            label='Cancel'
            onClick={onCancelClick}
            className='g_m_right_50'
            disabled={submitted}
          />
          <ButtonUI
            label='Set Due Date'
            onClick={onSubmitClick}
            busy={submitted}
            primary={true}
            disabled={!dueDate || submitted}
          />
        </div>
      </div>
    </div>
  )
}

export default SetCSDueDateModalUI